module.exports = __webpack_public_path__ + "img/Volume.f18fe755.svg";